module.exports = __webpack_public_path__ + "img/verify.8e887330.png";